// src/components/filter.
import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "./taggedcustomerlisttablecontainer"
import {
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import {
  delearManufactureOrdersGet,
  delearResellingTagProductCustomerGet,
} from "store/actions"
import axios from "axios"
import {
  ADMINSOLDPRODUCT,
  DEALERMANUFACTUREORDERSGET,
  HOSTNAME,
} from "config/config"
import { toast } from "react-toastify"
const getUserData = JSON.parse(localStorage.getItem("authUser"))

function extractIdAndPName(item) {
  let dealercustomerstatustext

  if (item.dealercustomerstatus === 0) {
    dealercustomerstatustext = "Pending"
  } else if (item.dealercustomerstatus === 1) {
    dealercustomerstatustext = "Accepted"
  } else if (item.dealercustomerstatus === 2) {
    dealercustomerstatustext = "Rejected"
  } else {
    dealercustomerstatustext = "Unknown Status"
  }
  return {
    id: item.id,
    customerName: `${item.tagcustomer && item.tagcustomer.firstName} ${
      item.tagcustomer && item.tagcustomer.lastName
    }`,
    contactNumber: `${item.tagcustomer && item.tagcustomer.contactNumber}`,
    city: `${item.tagcustomer && item.tagcustomer.city}`,
    pname: `${item.product && item.product.pname}`,
    pnumber: `${item.product && item.product.pnumber}`,
    status: item.status,
    statustext: item.statustext,
    isSold: item.isSold,
    isSoldtext: item.isSold ? "Yes" : "No",
    serialNumbers: `${item.product && item.product.serialNumbers}`,
    dealercustomerstatus: item.dealercustomerstatus,
    dealercustomerstatustext: dealercustomerstatustext,
    reason: item.reason,
  }
}

function DatatableTables() {
  const [rejectReasonModal, setRejectReasonModal] = useState(false)
  const [rejectReason, setRejectReason] = useState(null)

  const viewRejectReason = row => {
    setRejectReasonModal(!rejectReasonModal)
    setRejectReason(row?.reason)
  }

  const columns = useMemo(
    () => [
      {
        Header: "Sr.No",
        accessor: "id",
      },
      {
        Header: "Customer Name",
        accessor: "customerName",
      },
      {
        Header: "Contact Number",
        accessor: "contactNumber",
      },
      {
        Header: "Customer City",
        accessor: "city",
      },
      {
        Header: "Product Name",
        accessor: "pname",
      },
      {
        Header: "Product Number",
        accessor: "pnumber",
      },
      {
        Header: "Product Serial Number",
        accessor: "serialNumbers",
      },
      {
        Header: "Status",
        accessor: "dealercustomerstatustext",
      },
      {
        Header: "Is Sold",
        accessor: "isSoldtext",
      },
      {
        Header: "  ",
        Cell: cellProps => {
          const row = cellProps.row.original
          if (row.dealercustomerstatus == 1 && row.isSold == false) {
            return (
              <UncontrolledDropdown>
                <DropdownToggle tag="a" className="card-drop">
                  <i className="bx bx-dots-vertical fs-4"></i>
                </DropdownToggle>

                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem onClick={e => soldData(0, row.id)}>
                    <i
                      className="font-size-16 text-success me-1"
                      id="edittooltip"
                    ></i>
                    Mark as a sold
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Mark as a sold
                    </UncontrolledTooltip>
                  </DropdownItem>

                  {/* <DropdownItem onClick={e => soldData(1,row.id)}
                        >
                          <i className="font-size-16 text-success me-1" id="edittooltip"></i>
                          Mark as sold next year
                          <UncontrolledTooltip placement="top" target="edittooltip">
                          Mark as sold next year
                          </UncontrolledTooltip>
                        </DropdownItem>
         */}
                </DropdownMenu>
              </UncontrolledDropdown>
            )
          } else {
            return ""
          }
        },
      },
      {
        Header: " ",
        Cell: cellProps => {
          const row = cellProps.row.original

          return (
            <>
              {row.status === 2 && (
                <UncontrolledDropdown direction="start">
                  <DropdownToggle size="sm" color="">
                    <i className="bx bx-dots-vertical fs-4"></i>
                  </DropdownToggle>

                  <DropdownMenu>
                    <DropdownItem onClick={() => viewRejectReason(row)}>
                      View Reason
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
            </>
          )
        },
      },
    ],
    []
  )

  let data = []
  const dispatch = useDispatch()

  useEffect(() => {
    // const isUserLoggedIn = localStorage.getItem("isLoggedIn")
    // if (!isUserLoggedIn) {
    //   localStorage.setItem("isLoggedIn", "true")
    //   window.location.reload()
    // }
    dispatch(delearResellingTagProductCustomerGet({}, {}))
  }, [])

  const dealer_resellingproductlistData = useSelector(
    state => state.DelearProductGet
  )

  if (
    dealer_resellingproductlistData &&
    dealer_resellingproductlistData.resellingtagproductcustomerDetails
  ) {
    data =
      dealer_resellingproductlistData.resellingtagproductcustomerDetails.results.data.map(
        extractIdAndPName
      )
  }

  const soldData = (year, id) => {
    // alert(year)
    // alert(id)
    let url = `${HOSTNAME}${ADMINSOLDPRODUCT}?year=${year}&oid=${id}&soldType=0`
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: url,
      headers: {
        Authorization: `${getUserData.userData.token}`,
      },
    }

    axios
      .request(config)
      .then(response => {
        toast.success("Product sold successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        dispatch(delearResellingTagProductCustomerGet({}, {}))
      })
      .catch(error => {
        toast.error("Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        })
        // dispatch(delearResellingTagProductCustomerGet({}, {}))
      })
  }

  //meta title
  document.title = "Equipments Products"

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Tables" breadcrumbItem="Equipments Products" />
        {/* <Table columns={columns} data={data} /> */}
        <TableContainer
          count={
            dealer_resellingproductlistData.resellingtagproductcustomerDetails &&
            dealer_resellingproductlistData.resellingtagproductcustomerDetails
              .count
          }
          next={
            dealer_resellingproductlistData.resellingtagproductcustomerDetails &&
            dealer_resellingproductlistData.resellingtagproductcustomerDetails
              .next
          }
          previous={
            dealer_resellingproductlistData.resellingtagproductcustomerDetails &&
            dealer_resellingproductlistData.resellingtagproductcustomerDetails
              .previous
          }
          columns={columns}
          data={data}
          isGlobalFilter={true}
          isAddOptions={false}
          customPageSize={10}
          className="custom-header-css"
        />

        <Modal
          isOpen={rejectReasonModal}
          role="dialog"
          size="md"
          autoFocus={true}
          centered
          id="verificationModal"
          toggle={viewRejectReason}
        >
          <div className="modal-content">
            <ModalHeader toggle={viewRejectReason}>
              Reason for rejection
            </ModalHeader>
            <ModalBody>
              <p> </p>

              <FormGroup className="mb-3">
                <Label htmlFor="">View reason</Label>
                <Input
                  type="textarea"
                  name="product-name"
                  className="form-control"
                  placeholder="Enter Text Here"
                  disabled
                  value={rejectReason}
                />
              </FormGroup>
            </ModalBody>
          </div>
        </Modal>
      </div>
    </div>
  )
}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DatatableTables
